import { Directive, HostBinding, HostListener } from '@angular/core';
import * as $ from 'jquery';

@Directive({
    selector: '[appExpandMenu]'
})

export class AppExpandMenu {

    @HostBinding('class.active') isOpen = false;

    @HostListener('click', ['$event.target']) toggleOpen($event) {
        this.isOpen = !this.isOpen;

        $( document ).ready(() => {
            const id = $($event).attr('id');
            if (this.isOpen) {
                $('.expand-' + id).slideDown({
                    complete: () => {
                        $('#' + id).addClass('arrow-down-right');
                        $('#' + id).removeClass('arrow-down');
                    }
                });
            } else {
                $('.expand-' + id).slideUp({
                    complete: () => {
                        $('#' + id).removeClass('arrow-down-right');
                        $('#' + id).addClass('arrow-down');
                    }
                });
            }
        });
    }
}
